import React from 'react';
import clsx from 'clsx';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import {
  IconButton, 
  Input, 
  InputLabel, 
  InputAdornment, 
  FormControl,
  Box
} from '@mui/material';
import './robotSearch.css'
import { Search, Clear } from '@mui/icons-material';
import {useTranslation} from 'react-i18next';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    margin: {
      marginTop:'8px',

      display:'flex',
      flexDirection:'row',

    },
    withoutLabel: {
      paddingTop: theme.spacing(3),
    },
    
    input: {
     
      marginLeft:theme.spacing(2),
     
    },
    textField: {
     
      width: '100%',   
    },
  }),
);

export default function robotSearch ({doSearch, doCancel=() => {console.log('111');}}) {
  const classes = useStyles();
  const [t] = useTranslation()
  const [value, setValue] = React.useState('');
  const handleChange = (event) => setValue(event.target.value);
  const handleMouseDown = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  return (
    <FormControl className={clsx(classes.margin, classes.textField)}>
      
      <Input
        
        style={{flexGrow:1, marginTop:'0px', height:'46px',  paddingRight:'46px'}}
        id="searchInput"
        placeholder={t('Search product name')}
        type='text'
        value={value}
        onKeyDown={(event) => {
          
          if (event.keyCode==13) {
            // console.log("event=",event,value)
            doSearch(value)
          }
        }}
        onChange={handleChange}
        // endAdornment={
        //   <InputAdornment position="end">
        //     {value&&<IconButton
        //       onClick={() => {doSearch(''); doCancel();setValue('')}}
        //       onMouseDown={handleMouseDown}
        //     ><Clear/></IconButton>}
            

        //   </InputAdornment>
        // }
      />
      <Box   style={{ width:'46px', height:'46px', display:'flex', justifyContent:'center', alignItems:'center',marginLeft:'-46px'}}>
        <IconButton
          onClick={() => doSearch(value)}
          onMouseDown={handleMouseDown}
          size="large"><Search htmlColor='black' /></IconButton>
      </Box>
      
    </FormControl>
  );
}